import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SalesUser } from "../models/SalesUser";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";

export interface ChangeCoinsModel {
    coins: number;
    operation: 'add' | 'subtract';
}

@Injectable({
    providedIn: 'root',
})
export default class SalesUserService {
    baseUrl = `${environment.backend.baseUrl}${environment.backend.apiUrl}/`;
    constructor(private http: HttpClient) { }

    getMe(): Observable<SalesUser> {
        return this.http.get<SalesUser>(`${this.baseUrl}SalesUser/me`);
    }

    getSalesUsers(): Observable<SalesUser[]> {
        return this.http.get<SalesUser[]>(`${this.baseUrl}SalesUser`);
    }

    getSalesUser(azureObjectId: string) : Observable<SalesUser> {
        return this.http.get<SalesUser>(`${this.baseUrl}SalesUser/${azureObjectId}`);
    }

    changeCoins(id: number, model: ChangeCoinsModel): Observable<SalesUser> {
        console.log('Changing coins for', id, 'with model', model);
        return this.http.post<SalesUser>(`${this.baseUrl}SalesUser/changeCoins/${id}`, model);
    }

    addCoinsToCustomer(customerNo: number, model: ChangeCoinsModel): Observable<SalesUser> {
        return this.http.post<SalesUser>(`${this.baseUrl}SalesUser/addCoinsToCustomer/${customerNo}`, model);
    }
}